var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21,
    fill: "#003D76",
    stroke: "#003D76",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.819 22.0779C38.819 31.3672 31.2887 38.8975 21.9994 38.8975C12.71 38.8975 5.17969 31.3672 5.17969 22.0779C5.17969 12.7885 12.71 5.25818 21.9994 5.25818C31.2887 5.25818 38.819 12.7885 38.819 22.0779Z",
    fill: "#003D76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2333 30.254C19.7059 30.254 19.1757 30.0871 18.7288 29.7458L11.7468 22.6448C10.6688 21.8219 10.4688 20.2895 11.3005 19.2225C12.1319 18.1557 13.68 17.9578 14.7581 18.7807L19.9342 24.5033L28.4518 15.1729C29.3646 14.1731 30.9233 14.0949 31.9337 14.9986C32.9438 15.9017 33.0229 17.4448 32.1098 18.4446L22.0635 29.4498C21.579 29.9805 20.9085 30.254 20.2333 30.254Z",
    fill: "#FFFDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.6178798ab8eae04ac620fd7ef3889617.svg";
export { ForwardRef as ReactComponent };